module.exports = __webpack_public_path__ + "static/media/pin_compras.27726f77.png";